import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const useChangePassword = (token) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const changePassword = async (userId, currentPassword, newPassword) => {
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/admin/users/${userId}/change_password/`,
        {
          current_password: currentPassword,
          new_password: newPassword,
        },
        {
          headers: { Authorization: `Token ${token}` },
        }
      );
      setSuccess(true);
      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 
                          error.response?.data?.error || 
                          "Failed to change password";
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setError("");
    setSuccess(false);
    setLoading(false);
  };

  return {
    changePassword,
    loading,
    error,
    success,
    resetState,
  };
};

export default useChangePassword;